import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "vue";
import { LogService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilterChip',
  props: {
    label: { default: "Default title" },
    value: { default: "" }
  },
  setup(__props: any) {

const props = __props as { label: string, value: string | any[] };


const { label, value } = toRefs(props);

const createChipText = (): string => {
  // if this.value is a string
  if (typeof value.value === "string" && value.value) {
    return `${label.value}: ${value.value}`;
  } else if (Array.isArray(value.value) && value.value.length === 0) {
    LogService.error("SearchFilterChip: value is an empty array");
    return label.value;
  }
  let name;
  // if not a string then it is an array and not empty (from above)
  if (typeof value.value[0] === "string") {
    name = value.value[0];
  } else {
    name = value.value[0]?.name;
  }
  let _label = `${label.value}: ${name}`;
  if (value.value.length > 1) _label += ` + ${value.value.length - 1} more`;
  return _label;
};

return { __sfc: true,props, label, value, createChipText }
}

})